document.addEventListener('DOMContentLoaded', function () {
  console.log("Page is fully loaded");
  
  if (document.body.classList.contains('template-index')) {
    console.log("Page is home page index");
    
        const slider = document.querySelector('.homepage-slider');
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
    
        const flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          autoPlay: false, // Disable built-in autoplay
          pageDots: true,
          prevNextButtons: true
        });
    
        const slides = slider.querySelectorAll('.swiper-slide');
        let timeoutId = null;
    
        function playSlide(index) {
          clearTimeout(timeoutId);
    
          // Pause all videos
          slides.forEach((slide) => {
            const video = slide.querySelector('video');
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
          });
    
          const currentSlide = slides[index];
          const video = currentSlide.querySelector(isMobile ? '.mobile-video' : '.desktop-video');
    
          if (video) {
            video.play().catch(() => {
              // If autoplay fails (e.g. not muted), fallback to timeout
              timeoutId = setTimeout(() => flkty.next(), 6000);
            });
    
            // When video metadata is ready, wait for its duration
            if (video.readyState >= 1) {
              timeoutId = setTimeout(() => flkty.next(), video.duration * 1000);
            } else {
              video.onloadedmetadata = () => {
                timeoutId = setTimeout(() => flkty.next(), video.duration * 1000);
              };
            }
          } else {
            // Image-only slide, fallback to 5s
            timeoutId = setTimeout(() => flkty.next(), 5000);
          }
        }
    
        // Initial slide
        playSlide(flkty.selectedIndex);
    
        // On slide change
        flkty.on('change', function (index) {
          playSlide(index);
        });
    
 
  }
});